import { jsx as C } from "react/jsx-runtime";
const l = () => /* @__PURE__ */ C(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.75 5C21.75 4.0335 20.9665 3.25 20 3.25H4C3.0335 3.25 2.25 4.0335 2.25 5V16L2.2501 16.014V19.0858C2.2501 20.6448 4.13511 21.4256 5.23755 20.3232L7.73744 18.0732C7.78433 18.0263 7.84792 18 7.91422 18H20C20.9665 18 21.75 17.2165 21.75 16.25V5ZM12 12C11.4477 12 11 11.5299 11 10.95V7.05C11 6.4701 11.4477 6 12 6C12.5523 6 13 6.4701 13 7.05V10.95C13 11.5299 12.5523 12 12 12ZM12.0066 15C12.5553 15 13 14.5523 13 14C13 13.4477 12.5552 13 12.0066 13H11.9934C11.4447 13 11 13.4477 11 14C11 14.5523 11.4447 15 11.9934 15H12.0066Z",
    fill: "currentColor"
  }
);
export {
  l as default
};
